// GENERATED FILE - DO NOT MODIFY

export enum UpdatePolicyBundleTeamsActionDto {
    Add = "Add",
    Remove = "Remove",
}